module.exports = __webpack_public_path__ + "static/media/zp.c0d9f2f1.svg";